import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Sidebar from "../components/core/Dashboard/Sidebar"

function Dashboard(props) {
    const {loading: authLoading} = useSelector((state) => state.auth);
    const {loading: profileLoading} = useSelector((state) => state.profile);
    const {user} = useSelector((state) => state.profile)

    if(profileLoading || authLoading)
    {
        return (
            <div className='flex w-full h-screen justify-center items-center'>
                <div className='spinner mt-20'></div>
            </div>
        )
    }

    return (
        <div className='relative w-full flex min-h-[calc(100vh-3.5rem)]'>
            {/* side bar */}
            <Sidebar/>
            {/* nested component */}
            <div className='h-[calc(100vh-3.5rem)] w-full overflow-auto'>
                {/* changed width */}
                <div className='mx-auto w-11/12 max-w-[1000px] py-10'>
                    <Outlet/>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;